import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBars = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#787887"
      d="M5.958 10.833a.617.617 0 0 1-.625-.625v-1.25c0-.312.274-.625.625-.625h16.25c.313 0 .625.313.625.625v1.25a.64.64 0 0 1-.625.625zm18.75 3.75c.313 0 .625.313.625.625v1.25a.64.64 0 0 1-.625.625H8.458a.617.617 0 0 1-.625-.625v-1.25c0-.312.274-.625.625-.625zm-2.5 6.25c.313 0 .625.313.625.625v1.25a.64.64 0 0 1-.625.625H5.958a.617.617 0 0 1-.625-.625v-1.25c0-.312.274-.625.625-.625z"
    />
  </svg>
);
export default SvgBars;
